/**
 * Methods initializes all PTA vacancies JS features
 */
he.career.vacancies.init = function () {
    he.career.upload();

    // get vacancy <select>
    var selectVacancy = $(document.getElementById('vacancy'));

    /**
     * Set text to first element and change property to disabled
     */
    selectVacancy.find('>:first-child').text('Bewerbung als *').prop('disabled', true).prop('required', true);

    /**
     * Add vacancies to select element
     */
    $.each(he.career.vacancies.vacancies, function (key, value) {
        selectVacancy.append($("<option></option>")
            .attr("value", key)
            .text(value));
    });
};